

<template>
  <div class="v-data-footer" :class="is_mobile ? 'center-pagination': ''">

    <div class="v-data-footer__select">
      <span class="pagination-item" v-if="!is_mobile" > {{ $vuetify.lang.translator('pagination.page') }} </span>
      <v-select
        v-if="!is_mobile"
        v-model="items_per_page_model"
        dense
        hide-details
        :value="items_per_page"
        @change="change_items_per_page"
        :items="per_page_choices"
        :disabled="!allow_change_items_per_page"
        height="32"
      >
      </v-select>

      <span v-if="!is_mobile" class="pl-2 pagination-item">
        {{ (current_page - 1) * items_per_page + 1 }} -
        {{ last_item_page }} 
        {{ $vuetify.lang.translator('pagination.of') }}
        {{ total_units }}
      </span>
      <span v-if="is_mobile" class="pl-2 pagination-item">
        {{ $vuetify.lang.translator('pagination.page_mobile') }}
        {{ current_page }}
        {{ $vuetify.lang.translator('pagination.of') }}
        {{ total_pages }}
      </span>

      <ul class="pagination">
        <li class="pagination-item">
          <v-btn
            @click="on_click_first_page"
            :disabled="is_in_first_page"
            icon
            small
          >
            <v-icon>{{ first_page_icon }}</v-icon>
          </v-btn>
        </li>

        <li class="pagination-item">
          <v-btn
            @click="on_click_previous_page"
            :disabled="is_in_first_page"
            icon
            small
          >
            <v-icon>{{ previous_page_icon }}</v-icon>
          </v-btn>
        </li>

        <!-- Visible Buttons Start -->

        <li class="pagination-item page-input">
          <v-text-field
            v-model="search_page"
            type="number"
            dense
            center
            hide-details
            outlined
            class="explorer-input-page ma-0 pa-0 "
            @blur="search"
            @keydown.enter.prevent="search"
          />
        </li>

        <!-- Visible Buttons End -->

        <li class="pagination-item">
          <v-btn
            @click="on_click_next_page"
            :disabled="is_in_last_page"
            small
            icon
          >
            <v-icon>{{ next_page_icon }}</v-icon>
          </v-btn>
        </li>

        <li class="pagination-item">
          <v-btn
            @click="on_click_last_page"
            :disabled="is_in_last_page"
            icon
            small
          >
            <v-icon>{{ last_page_icon }}</v-icon>
          </v-btn>
        </li>
      </ul>
    </div>
  </div>
</template>


<style lang="scss">
 @import '@/sass/qpagination.scss';
</style>


<script>
 import {mapState} from 'vuex';
 export default {
   name: 'QPagination',

   props: {
     max_visible_buttons: {
       type: Number,
       required: false,
       default: 3,
     },
     current_page: {
       type: Number,
       required: true,
       default: 0
     },
     total_units: {
       type: Number,
       required: true,
     },
     allow_change_items_per_page: {
       type: Boolean,
       required: false,
       default: false,
     },
     per_page_choices: {
       type: Array,
       required: false,
       default: () => [
         { text: '5', value: 5 },
         { text: '10', value: 10 },
         { text: '15', value: 15 },
         { text: '20', value: 20 },
       ],
     },
     items_per_page: {
       type: Number,
       required: false,
       default: 10,
     },
     units_length: {
       type: Number,
       required: false,
       default: 10,
     },
     first_page_icon: {
       type: String,
       required: false,
       default: 'mdi-page-first',
     },
     previous_page_icon: {
       type: String,
       required: false,
       default: 'mdi-chevron-left',
     },
     last_page_icon: {
       type: String,
       required: false,
       default: 'mdi-page-last',
     },
     next_page_icon: {
       type: String,
       required: false,
       default: 'mdi-chevron-right',
     },
   },

   data: () => ({
     items_per_page_model: 10,
     search_page: '',
     isTyping: false,
   }),

   mounted() {
     if (this.items_per_page)
       this.items_per_page_model = this.items_per_page;
     this.search_page = (''+this.current_page) || '1';
   },

   computed: {
     ...mapState(['is_mobile']),
     total_pages() {
       return Math.ceil(this.total_units / this.items_per_page)
     },

     is_in_first_page() {
       if (this.total_pages == 0 ) return true
       return this.current_page === 1
     },

     is_in_last_page() {
       if (this.total_pages == 0 ) return true
       return this.current_page === this.total_pages
     },

     last_item_page() {
      return this.is_in_last_page ? this.total_units : this.current_page * this.items_per_page;
     }
   },

   methods: {
     change() {
       this.isTyping=true
     },

     on_click_first_page() {
       this.$emit('page_changed', 1)
     },

     on_click_previous_page() {
       this.$emit('page_changed', this.current_page - 1)
     },

     on_click_page(page) {
       this.$emit('page_changed', page)
     },

     on_click_next_page() {
       this.$emit('page_changed', this.current_page + 1)
     },

     on_click_last_page() {
       this.$emit('page_changed', this.total_pages)
     },

     change_items_per_page() {
       this.$emit('items_per_page_changed', this.items_per_page_model)
     },


     search() {
       let page = +this.search_page;
       if (page < 1) {
         page = 1;
       } else if (page > this.total_pages) {
         page = this.total_pages
       }
       this.search_page = ''+page;
       if (page != this.current_page) {
         this.on_click_page(page)
       }
     }
   },

   watch: {
     items_per_page(now, pre) {
       if (now != pre)
         this.items_per_page_model = now;
     },

     current_page(val) {
       this.search_page = ''+val;
     }
   },
 }
</script>
